import cls from 'classnames';
import { ErrorMessage, Form, Formik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { useState, useEffect, useCallback } from "react";
import { calculateTotals, calculatePromoCodes, loadCartListDetails, createOrder,creatGuesteOrder } from "../../redux/actions";
import CartDetail from './CartDetail';
import DeliveryAddresses from "./DeliveryAddresses";
import BillingAddresses from './BillingAddresses';
import { guestUserOrderCreationSchema } from "../../utils/yup";
import { useDispatch } from 'react-redux';

const OrderSummary = ({ user, region, promocode, selectedLines, localCartId }) => {
    const [promoAppliedValue, setPromoAppliedValue] = useState(0);
    const [summary, setSummary]                     = useState({});
    const [paymentMethod, setPaymentMethod]         = useState([
        // 'bank_transfer', 'gateway', 'payment_on_delivery', 'corporate_credit'
        'payment_on_delivery', 'gateway', 'bank_transfer'
    ]);
    const [cartSummary, setCartSummary]             = useState([]);
    const [expandedCarts, setExpandedCarts]         = useState({});
    const [isLoading, setIsLoading]                 = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const toggleCartVisibility = (cartId) => {
        setExpandedCarts((prev) => ({
            ...prev,
            [cartId]: !prev[cartId], // Toggle state
        }));
    };

    const fetchCalculateTotals = useCallback(async () => {
        setIsLoading(true);
        let data = '';
        if (promocode) {
            localStorage.setItem('promocode', promocode);
            let company_id = user?.company?.id;
            data = await calculatePromoCodes(selectedLines, region, company_id, promocode);
        } else {
            data = await calculateTotals(selectedLines, region);
        }
    
        if (data?.message) {
            toast.error(data?.message);
            setSummary({ total_gross: 0, total_net: 0, total_promocode_discount: 0 });
            setPromoAppliedValue(0);
        } else {
            setSummary(data?.summary);
            setCartSummary(data?.cart_summaries || []); 
            if(data?.combined_available_payment_methods?.length > 0) {
                setPaymentMethod(data?.combined_available_payment_methods);
            }            
            setPromoAppliedValue(data?.summary?.total_promocode_discount ?? 0);
    
            if (data?.cart_summaries?.length > 0) {
                const initialExpandedState = data.cart_summaries.reduce((acc, cart) => ({
                    ...acc,
                    [cart.id]: true 
                }), {});
                setExpandedCarts(initialExpandedState);
            }
        }
        setIsLoading(false);
    }, [selectedLines, region, promocode, user?.company?.id]);

    useEffect(() => {
        fetchCalculateTotals();
    }, [fetchCalculateTotals]);

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            setIsLoading(true);
            if(!values.preferred_delivery_date) {
                toast.error("Select deleivery date.");
            }
            if(!values.payment_method) {
                toast.error("Select payment method.");
            }

            let cartIds = [];
        
            if(user?.shopping_carts) {
                cartIds = user?.shopping_carts;
            } else if(localCartId) {
                cartIds = localCartId.map(item => item.cartId);
            }

            const final_cart_data = await loadCartListDetails(cartIds, dispatch);

            if(final_cart_data.length > 0) {            

                if(values.preferred_delivery_date && values.payment_method) {
                    values.pandadoc_recipients = [];
                    values.lpo_files = [];
                    values.notes = '';
                    values.ordered_region = region;
                    values.promo_code = localStorage.getItem("promocode") ?? '';
                    values.selectedLinesSummary = {
                        "subtotal"  : summary?.total_gross,
                        "vat"       : summary?.total_net - summary?.total_gross,
                        "shipping"  : 0,
                        "promotion" : promoAppliedValue,
                        "total"     : summary?.total_net - promoAppliedValue
                    };
                    values.selected_carts = final_cart_data
                        .filter(cart => cart?.lines?.length > 0) 
                        .map(cart => ({
                            shopping_cart_id          : cart?.id,
                            selected_lines            : cart?.lines.map(line => line?.product_variation?.id),
                            selected_transferred_carts: cart?.transferred_carts || [],
                            carts_quantity            : cart.lines.map(line => ({
                                item_id  : line.product_variation.id,
                                quantity : line.quantity
                            }))        
                        }));

                    let response = '';
                    if(user?.shopping_carts) {
                        response = await createOrder(values); 
                    } else {
                        response = await creatGuesteOrder(values);
                    }                       

                    if(response) {                        
                        if (values.payment_method === 'gateway') {

                            var form = document.createElement("form");
                            form.method        = 'POST';
                            form.target        = "_self";                      
                            form.style.display = 'none';
                            
                            if(response.CURRENCY_CODE === 'QAR') {                                

                                if (!response?.url) {
                                    toast.error('Payment gateway URL is empty.');

                                    setIsLoading(false);
                                    return;
                                } else {                                    
                                    form.action  = response.url;
                
                                    for (var key in response) {
                                        var mapInput   = document.createElement("input");
                                        mapInput.type  = "hidden";
                                        mapInput.name  = key;
                                        mapInput.value = response[key];
                                        form.appendChild(mapInput);
                                    }
                
                                    document.body.appendChild(form);
                                    form.submit();

                                    setIsLoading(false);
                                    return;
                                }
                            } else if(response.currency_code === 'AED' || response.currency_code === 'OMR') {
                                if (!response?.redirect_url) {
                                    toast.error('Payment gateway URL is empty.');

                                    setIsLoading(false);
                                    return;
                                } else {                                   
                                    form.action = response.redirect_url;
                    
                                    document.body.appendChild(form);
                                    form.submit();

                                    setIsLoading(false);
                                    return;
                                }
                            }
                        } else if (values.payment_method === 'bank_transfer') {
                            dispatch({ type: 'cart/setCount', payload: 0 });
                            navigate(`/thank-you/?reference=${response?.reference_nr}`);

                            setIsLoading(false);
                            return;
                        } else {
                            dispatch({ type: 'cart/setCount', payload: 0 });
                            navigate("/thank-you?success=true");

                            setIsLoading(false);
                            return;
                        }
                        if(response?.message) {
                            toast.error(response?.message);
                            setIsLoading(false);   
                        }
                    }
                }
            }
            setIsLoading(false);
        } catch (error) {     
            toast.error(error);       
            console.log(error);
            setIsLoading(false);
        }
        setSubmitting(false);
    };

    return (
        <div className='row gy-4'>      
            {cartSummary?.length > 0 ? (    
                <>
                    <div className='col-xl-6 col-lg-6'>
                        {/* fields */}
                        <Formik
                            initialValues={{
                                email : '',
                                first_name: '',
                                company_name  : '',
                                phone_nr : '',
                                phone_area_code: '+971',
                                city: '',
                                street: '',
                                country: 'AED',    
                                payment_method: '',                    
                                preferred_delivery_date: ''
                            }}                    
                            onSubmit={onSubmit}
                            validationSchema={!user?.shopping_carts ? guestUserOrderCreationSchema : ""}
                        >
                            {({ values, touched, errors, handleChange }) => (
                                <Form>
                                    <div className="cart-table border border-gray-100 rounded-8 px-20 py-28">   
                                        {user?.shopping_carts && (
                                            <>
                                                <DeliveryAddresses cartSummary = {cartSummary} />
                                                <BillingAddresses  user = {user} />                                         
                                            </>  
                                        )}
                                        {!user?.shopping_carts && (  
                                            <> 
                                                <div class="row align-items-center mb-20">
                                                    <div class="col-md-4">
                                                        <h6 class="text-2xl m-0">User Details</h6>
                                                    </div>
                                                    <div class="col-md-8 text-end">
                                                        <span class="small">
                                                            Already have an account?&nbsp;
                                                            <Link
                                                                to="/login"
                                                                className="btn-primary text-decoration-underline"
                                                            >
                                                                Log in
                                                            </Link>
                                                        </span>
                                                    </div>
                                                </div>                                                
                                                <div className='row p-5'>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="email"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            E-mail address{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="email"
                                                            className="common-input input-font"
                                                            name="email"
                                                            id="email"
                                                            onChange={(e) => {
                                                                handleChange(e);
                                                            }}
                                                            value={values.email}
                                                            autoComplete="off"
                                                        />
                                                        {errors.email && touched.email && (
                                                            <ErrorMessage
                                                                name="email"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="first_name"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Name{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="common-input input-font"
                                                            name="first_name"
                                                            id="first_name"
                                                            onChange={handleChange}
                                                            value={values.first_name}
                                                            autoComplete="off"                                                    
                                                        />
                                                        {errors.first_name && touched.first_name && (
                                                            <ErrorMessage
                                                                name="first_name"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                </div>
                                                <div className='row p-5'>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="phone_area_code"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Area code{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            className="common-input input-font"
                                                            name="phone_area_code"
                                                            id="phone_area_code"
                                                            onChange={handleChange}
                                                            value={values.phone_area_code}
                                                        >
                                                            <option value={"+971"}>+971</option>
                                                            <option value={"+974"}>+974</option>
                                                            <option value={"+968"}>+968</option>
                                                        </select>
                                                        {errors.phone_area_code && touched.phone_area_code && (
                                                            <ErrorMessage
                                                                name="phone_area_code"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="phone_nr"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Phone number{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="common-input input-font"
                                                            name="phone_nr"
                                                            id="phone_nr"
                                                            onChange={handleChange}
                                                            value={values.phone_nr}
                                                            autoComplete="off"                                                    
                                                        />
                                                        {errors.phone_nr && touched.phone_nr && (
                                                            <ErrorMessage
                                                                name="phone_nr"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                </div>
                                                <div className='row p-5'>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="company_name"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Company Name
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="common-input input-font"
                                                            name="company_name"
                                                            id="company_name"
                                                            onChange={handleChange}
                                                            value={values.company_name}
                                                            autoComplete="off"                                                    
                                                        />
                                                        {errors.company_name && touched.company_name && (
                                                            <ErrorMessage
                                                                name="company_name"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="street"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Street{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="common-input input-font"
                                                            name="street"
                                                            id="street"
                                                            onChange={handleChange}
                                                            value={values.street}
                                                            autoComplete="off"                                                    
                                                        />
                                                        {errors.street && touched.street && (
                                                            <ErrorMessage
                                                                name="street"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                </div>
                                                <div className='row p-5'>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="city"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            City{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="common-input input-font"
                                                            name="city"
                                                            id="city"
                                                            onChange={handleChange}
                                                            value={values.city}
                                                            autoComplete="off"                                                    
                                                        />
                                                        {errors.city && touched.city && (
                                                            <ErrorMessage
                                                                name="city"
                                                                component="div"
                                                                className="text-danger lable-font"
                                                            />
                                                        )}
                                                    </span>
                                                    <span className='col-md-6'>
                                                        <label
                                                            htmlFor="country"
                                                            className="lable-font text-neutral-900 mb-8 fw-medium"
                                                        >
                                                            Country{" "}
                                                            <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            className="common-input input-font"
                                                            name="country"
                                                            id="country"
                                                            onChange={handleChange}
                                                            value={values.country}
                                                        >
                                                            <option value={"QAR"}>Qatar</option>
                                                            <option value={"AED"}>United Arab Emirates</option>
                                                            <option value={"OMR"}>Oman</option>
                                                            <option value={"SAR"}>Kingdom of Saudi Arabia</option>
                                                        </select>
                                                        {errors.country && touched.country && (
                                                            <ErrorMessage
                                                                name="country"
                                                                component="div"
                                                                className="text-danger lable-font" 
                                                            />
                                                        )}
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                        {/* payment data */}
                                        {paymentMethod ? (
                                            <div
                                                className={cls({
                                                    'cart-table border border-gray-100 rounded-8 px-20 py-28 mt-20': user?.shopping_carts,
                                                }, 'p-5')}
                                            >  
                                                {/* <h6 className="text-2xl mt-10">Delivery Time</h6> */} 
                                                <h6 className="lable-font mt-10">Delivery Time  <span className="text-danger">*</span></h6>             
                                                <div className="mb-16 space-y-4">
                                                    <input 
                                                        type="date" 
                                                        name = "preferred_delivery_date"
                                                        min={new Date().toISOString().split("T")[0]} 
                                                        value={values.preferred_delivery_date}
                                                        className="w-full border border-gray-300 p-10 rounded-lg input-font"
                                                        onChange={(e) => {
                                                            handleChange(e);                                                    
                                                        }} 
                                                    />
                                                </div>  

                                                {/* <h6 className="text-2xl mt-10">Payment</h6>   */}
                                                <h6 className="lable-font mt-10">Payment  <span className="text-danger">*</span></h6>  
                                                    
                                                <div className="mb-16 space-y-4">
                                                    {paymentMethod.map(method => (
                                                        <div key={method} className="flex items-center">
                                                            <input 
                                                                type="radio" 
                                                                name="payment_method" 
                                                                id={method} 
                                                                value={method} 
                                                                checked={values.payment_method === method} 
                                                                className="w-16 h-16 accent-blue-500"
                                                                onChange={handleChange} 
                                                            />
                                                            <label 
                                                                htmlFor={method} 
                                                                className="input-font font-semibold text-gray-800 ml-10 mt-5"
                                                            >
                                                                {method === 'payment_on_delivery' && (
                                                                    <>Pay with cash on delivery</>
                                                                )}
                                                                {method === 'gateway' && (
                                                                    <>Pay with card now</>
                                                                )}
                                                                {method === 'bank_transfer' && (
                                                                    <>Pay by bank transfer</>
                                                                )}
                                                                {method === 'corporate_credit' && (
                                                                    <>Corporate Credit</>
                                                                )}
                                                            </label>
                                                        </div>
                                                    ))}
                                                </div> 
                                                <div className="flex-align gap-8 d-flex flex-column p-5"> 
                                                    {isLoading ? (
                                                        <i className="ph ph-spinner animate-spin text-2xl d-flex" /> 
                                                    ) : (
                                                        < button type="submit" className="btn align-items-center w-50 mt-2 bg-main-product-50 hover-bg-main-product-50" >Place Order</button>
                                                    )}  
                                                </div>                            
                                            </div>
                                        ) : (
                                            <></>
                                        )}  
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                    {/* Order summary */}
                    <div className='col-xl-6 col-lg-6'>
                        {/* <div className="cart-table border border-gray-100 rounded-8 px-20 py-28 bg-color-one"> */}
                        <div className="cart-table border border-gray-100 rounded-8 px-20 py-28 bg-light-grey">
                            <CartDetail  
                                cartSummary          = {cartSummary} 
                                promoAppliedValue    = {promoAppliedValue}  
                                summary              = {summary} 
                                expandedCarts        = {expandedCarts}
                                toggleCartVisibility = {toggleCartVisibility}
                            />
                        </div>
                    </div>
                </>
            ) : (
                <div className='col-xl-12 col-lg-12'>
                    <div className="cart-table border border-gray-100 rounded-8 px-20 py-28 ">
                        <h6 className="text-gray-500 mt-40 mb-40 p-40 text-center">No items in the cart.</h6>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrderSummary;
